/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListShiftManagerPositionsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'string',
        },
      },
    },
  }],
} as const;
